import { Controller } from '@hotwired/stimulus';
import Modal from 'bootstrap/js/dist/modal';

export default class extends Controller {
    static values = {
        pageTag: String,
        title: String
    }

    modal = null;

    connect() {
        // Създаваме модалния прозорец динамично
        this.createModal();
    }

    disconnect() {
        if (this.modal) {
            this.modal.dispose();
        }
        const modalElement = document.getElementById('termsModal');
        if (modalElement) {
            modalElement.remove();
        }
    }

    async openModal(event) {
        event.preventDefault();
        
        const modalBody = document.getElementById('termsModalBody');
        const modalTitle = document.getElementById('termsModalTitle');
        
        // Показваме loading индикатор
        modalBody.innerHTML = '<div class="text-center p-5"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
        
        // Отваряме модала
        this.modal.show();
        
        try {
            // Зареждаме съдържанието
            const response = await fetch(`/${document.documentElement.lang}/page/terms-content?tag=${this.pageTagValue}`);
            
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            
            const data = await response.json();
            
            // Попълваме съдържанието
            modalTitle.textContent = data.title || this.titleValue;
            modalBody.innerHTML = data.content;
            
        } catch (error) {
            console.error('Error loading terms:', error);
            modalBody.innerHTML = '<div class="alert alert-danger">Грешка при зареждане на съдържанието.</div>';
        }
    }

    createModal() {
        // Проверяваме дали модалът вече съществува
        let modalElement = document.getElementById('termsModal');
        
        if (!modalElement) {
            // Създаваме модалния HTML
            modalElement = document.createElement('div');
            modalElement.innerHTML = `
                <div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="termsModalTitle" aria-hidden="true">
                    <div class="modal-dialog modal-xl modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" id="termsModalTitle">${this.titleValue}</h3>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body" id="termsModalBody">
                                <!-- Content will be loaded here -->
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary expanded" data-bs-dismiss="modal">${this.getCloseButtonText()}</button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            
            document.body.appendChild(modalElement.firstElementChild);
        }
        
        // Инициализираме Bootstrap Modal
        this.modal = new Modal(document.getElementById('termsModal'));
    }

    getCloseButtonText() {
        // Проверяваме езика и връщаме съответния текст
        const lang = document.documentElement.lang || 'bg';
        const closeTexts = {
            'bg': 'Затвори',
            'en': 'Close'
        };
        return closeTexts[lang] || 'Close';
    }
}
